<template>
  <div class="recent-activity-list px-2 px-md-4 py-2 py-md-4">
    <ConveyTable
      showSearch
      showDateRange
      tableClassName="recent-activity-table"
      searchMode="validPhoneSearch"
      :items="activities"
      :fields="fields"
      :sortBy="sortBy"
      :sortDesc="sortDesc"
      :perPageOptions="perPageOptions"
      :perPage="perPage"
      :currentPage="currentPage"
      :totalRows="totalRows"
      :isLoading="isLoading"
      :placeholders="placeholders"
      @onFetch="(options) => fetchRecentActivities(options)"
    >
      <template #cell(timestamp)="data">
        <span>{{ formatDate(data.value, "MMM D, YYYY h:mm a") }}</span>
      </template>
      <template #cell(agent)="data">
        <span>{{ data.item.agent_name }}</span>
      </template>
      <template #cell(recipient)="data">
        <span>{{ prettyPhoneNumber(data.item.recipient_number) }}</span>
      </template>
      <template #cell(conversations)="data">
        <router-link
          v-if="$auth.can('read:conversation')"
          :to="`/admin/conversations/${data.item.conversation_id}`"
          style="width: 100%; text-align: center; display: block"
        >
          View
        </router-link>
      </template>
      <template #cell(language)="data">
        <div v-if="data.value" class="d-flex justify-content-center align-items-center">
          <LanguageCode :languageCode="data.item.language_code" />
          <span class="ml-2">
            {{ data.value }}
          </span>
        </div>
      </template>
      <template #cell(activity)="data">
        <div class="d-flex align-items-start justify-content-start">
          <ActivitiesIcons
            :activityText="data.value"
            :fontScale="1.4"
          />
          <span class="ml-2 text-left">{{ data.value }}</span>
        </div>
      </template>
    </ConveyTable>
  </div>
</template>

<script>
/* eslint-disable */
import formatter from "@/mixins/formatter";
import errorHandler from "@/mixins/errorHandler";
import moment from "moment";
import { runGraphqlQuery } from "../../../graphql/utils";
import { makeRecentActivitiesQuery } from "../../../graphql/queries";
import LanguageCode from "../../common/LanguageCode.vue";
import ActivitiesIcons from "./ActivitiesIcons.vue";
import ConveyTable from "@/components/ConveyTable";

export default {
  name: "AdminConversationList",
  mixins: [formatter, errorHandler],
  components: {
    LanguageCode,
    ActivitiesIcons,
    ConveyTable,
  },
  data() {
    return {
      activities: [],
      fields: [
        { key: "recipient", sortable: false },
        { key: "agent", sortable: false },
        { key: "language", sortable: false },
        { key: "activity", sortable: false },
        { key: "timestamp", sortable: true },
        { key: "conversations", sortable: false, stickyColumn: true, class: "right-sticky-column actions-column" },
      ],
      perPage: 10,
      perPageOptions: [5, 10, 25, 50, 100],
      currentPage: 1,
      totalRows: 0,
      isLoading: true,
      sortBy: "timestamp",
      sortDesc: true,
      placeholders: {
        search: "Search...",
        daterange: "Select Date Range",
      },
      fetchAbortConroller: null,
    };
  },
  methods: {
    abortFetch() {
      if (this.fetchAbortConroller) {
        this.fetchAbortConroller.abort();
        this.fetchAbortConroller = null;
      }
    },
    async fetchRecentActivities(fetchOptions) {
      try {
        this.abortFetch();
        this.fetchAbortConroller = new AbortController();

        const {
          perPage,
          currentPage,
          startDate,
          endDate,
          sortBy,
          sortDesc,
          searchKey
        } = fetchOptions;
        this.isLoading = true;

        this.perPage = perPage;
        this.currentPage = currentPage;
        this.sortBy = sortBy;
        this.sortDesc = sortDesc;

        const offset = (currentPage - 1) * perPage;
        const query = makeRecentActivitiesQuery({
          startDate,
          endDate,
          offset,
          searchKey,
          orderBy: sortBy,
          sortDesc: sortDesc,
          perPage,
        });

        const res = await runGraphqlQuery(query, this.fetchAbortConroller.signal);
        const responseData = res.data.data.getActivities;
        this.totalRows = responseData.total;
        this.activities = responseData.data;
      } catch (err) {
        if (!this.isApiCanceled(err)) {
          console.log("[AdminRecentActivities:fetchRecentActivities] ERROR: ", err);
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  beforeDestroy() {
    this.abortFetch();
  }
};
</script>

<style lang="scss">
.recent-activity-list {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
